import React, { useState, useRef } from 'react'
import Modal from '../modal/modal'
import steps, { stepsDesc } from './steps'
import styles from './AddModal.scss'

{/*
  子组件主要参数、方法：
  
    selectedArr：选择的action项
    actionIndex：选择动作在action数组的索引
    inputValues：选择项中每个input输入值数组
    inputArr：保存单次选择action后所有input输入值

    handleSelect：选择action后的回调函数，设置上述参数

    handleOk：格式化选择数据并将选中参数传向父组件
*/}

const AddModal = ({ onConfirm, modalAction, onClose, editIndex, editItem }) => {
  const defaultSelectedIndex = editItem ? steps.findIndex(item => item.action === editItem.action) : 0
  const tempInputValues = editItem ? Object.keys(editItem.params) : []
  const defaultInputValues = editItem ? tempInputValues.map(item => ({ label: item, value: editItem.params[item] || '' })) : []
  const [selectedArr, setSelectedArr] = useState(steps.find((item, index) => index === defaultSelectedIndex).params)
  const [actionIndex, setActionIndex] = useState(defaultSelectedIndex)
  const [staticValues, setStaticValues] = useState(() => {
    const staticV = editItem ? Object.keys(editItem).filter(item => item !== 'action' && item !== 'params') : []
    return staticV.map(item => ({ label: item, value: editItem[item] ? editItem[item] : '' }))
  })
  const [inputValues, setInputValues] = useState(defaultInputValues)
  const [staticArr, setStaticArr] = useState(() => staticValues.map((item, index) => ({
    label: item.label,
    handleInputChange: e => {
      const tempValue = e.target.value
      setStaticValues(prevState => prevState.map((inputValue, inputIndex) => {
        if (inputIndex === index) {
          inputValue.value = tempValue
        }
        return inputValue
      }))
    }
  })))
  const [inputArr, setInputArr] = useState(() => tempInputValues.map((item, index) => ({
    label: item,
    handleInputChange: e => {
      const tempValue = e.target.value
      setInputValues(prevState => prevState.map((inputValue, inputIndex) => {
        if (inputIndex === index) {
          inputValue.value = tempValue
        }
        return inputValue
      }))
    }
  })))
  const select = useRef()
  const isSelect = (vnode, item) => {
    const node = vnode.find(e => e.action === steps[actionIndex].action).params
    if (item.indexOf('.') > -1) {
      const [temp0, temp1] = item.split('.')
      if (node[temp0][temp1] instanceof Array) {
        return [ true, node[temp0][temp1] ]
      }
    } else {
      if (node[item] instanceof Array) {
        return [ true, node[item] ]
      }
    }
    return [ false, null ]
  }
  const handleSelect = () => {
    const selectedIndex = select.current.options.selectedIndex
    setActionIndex(selectedIndex)
    setStaticValues(() => {
      const temp = []
      Object.keys(steps[selectedIndex]).forEach(item => {
        if (item !== 'action' && item !== 'params') {
          temp.push({ label: item, value: '' })
        }
      })
      return temp
    })
    setInputValues(() => steps[selectedIndex].params.map(item => ({ label: item, value: '' })))
    setStaticArr(() => {
      const temp = []
      Object.keys(steps[selectedIndex]).forEach(item => {
        if (item !== 'action' && item !== 'params') {
          temp.push({
            label: item,
            handleInputChange: e => {
              const tempValue = e.target.value
              setStaticValues(prevState => prevState.map(inputItem => {
                if (inputItem.label === item) {
                  inputItem.value = tempValue
                }
                return inputItem
              }))
            }
          })
        }
      })
      return temp
    })
    setInputArr(() => steps[selectedIndex].params.map(item => ({
      label: item,
      handleInputChange: e => {
        const tempValue = e.target.value
        setInputValues(prevState => prevState.map(inputItem => {
          if (inputItem.label === item) {
            inputItem.value = tempValue
          }
          return inputItem
        }))
      }
    })))
    setSelectedArr(steps[selectedIndex].params)
  }
  const handleOk = () => {
    let currentItem = null
    if (steps[actionIndex] && steps[actionIndex].action) {
      currentItem = {
        action: steps[actionIndex].action,
        params: {}
      }
      staticValues.forEach(item => {
        if (!currentItem[item.label]) {
          currentItem[item.label] = item.value
        }
      })
      inputValues.forEach(item => {
        if (!currentItem.params[item.label]) {
          currentItem.params[item.label] = item.value
        }
      })
    }
    if (currentItem) {
      onConfirm(currentItem, modalAction, editIndex)
    }
    onClose()
  }
  const handleCancel = () => {
    if (editItem) {
      onConfirm(editItem, modalAction, editIndex)
    }
    onClose()
  }
  return (
    <Modal
      onClose={handleCancel}
      title={modalAction === 'add' ? '添加动作' : '修改动作'}
    >
      <div>
        <div className={styles.modalContainer}>
          <div className={styles.context}>
            <p>
              <span>action</span>
              <span>
                <select
                  ref={select}
                  defaultValue={steps[defaultSelectedIndex].action}
                  onChange={handleSelect}
                >
                  {
                    steps.map(item => (
                      <option key={item.action}>{item.action}</option>
                    ))
                  }
                </select>
              </span>
            </p>
            {
              staticValues.map((item, index) => (
                <p key={index}>
                  <span>{item.label}</span>
                  <span>
                    <input
                      value={item.value}
                      onChange={staticArr.find(e => e.label === item.label).handleInputChange}
                    />
                  </span>
                </p>
              ))
            }
            {
              selectedArr.map((item, index) => (
                <p key={index}>
                  <span>{item}</span>
                  <span>
                    {
                      isSelect(stepsDesc, item)[0]
                        ? <select
                          defaultValue={inputValues.find(e => e.label === item).value}
                          onChange={inputArr.find(e => e.label === item).handleInputChange}
                        >
                        {
                          isSelect(stepsDesc, item)[1].map((step, stepIndex) => (
                            <option key={stepIndex} value={step.value}>{step.label}</option>
                          ))
                        }
                        </select>
                        : <input
                          value={inputValues.find(e => e.label === item).value}
                          onChange={inputArr.find(e => e.label === item).handleInputChange}
                        />
                    }
                  </span>
                </p>
              ))
            }
          </div>
          <div className={styles.footer}>
            <button onClick={handleOk}>确定</button>
            <button onClick={handleCancel}>取消</button>
          </div>
        </div>
      </div>
    </Modal>
  )
}

export default AddModal

